module.exports = __webpack_public_path__ + "static/media/live-project.3833ca1c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/live-project.webp
// module id = 539
// module chunks = 4